var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.8016H8.5H1C1 13.8016 3.5 12.095 3.5 6.12065C3.5 4.76288 4.02667 3.46031 4.96417 2.50019C5.9025 1.54007 7.175 1 8.5 1M9.94167 16.2019C9.79533 16.4446 9.5851 16.6461 9.33206 16.7862C9.07903 16.9263 8.79208 17 8.5 17C8.20792 17 7.92097 16.9263 7.66794 16.7862C7.4149 16.6461 7.20467 16.4446 7.05833 16.2019",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.8C16 13.8 13.633 12.0936 13.633 6.12C13.633 4.7624 13.1344 3.46 12.2467 2.5C11.3583 1.54 9.75451 1 8.5 1",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b4d726c40e7712c66378ad1c27c6430a.svg";
export { ForwardRef as ReactComponent };